import React, { Component } from 'react';
import { Tooltip } from 'reactstrap';
import Img from '../../StableImage';
import SceneButton from '../../components/buttons/SceneButton';
import Champion from './Champion';
import Entity from './Entity';
import Card from '../../components/cards/Card';
import './Shop.css';

export default class Reward extends Component {

  state = {

    tooltip: null
  }

  toggleTooltip (tooltip, touch) {

    if (tooltip === this.state.tooltip && this.state.tooltipDate && new Date() - this.state.tooltipDate < 500)
      return;

    if (touch) {
      
      if (this.tooltipTimeout)
        clearTimeout(this.tooltipTimeout);

      this.setState({tooltip: tooltip === this.state.tooltip ? null : tooltip, tooltipDate: new Date()});
      this.tooltipTouch = touch;
      this.tooltipTimeout = setTimeout(() => this.toggleTooltip(null), 3000);
      return;
    }

    this.setState({tooltip: tooltip === this.state.tooltip ? null : tooltip});
  }

  render () {

    let tooltips = []

    let src = this.props.src;
    let manager = this.props.manager;

    return (
      <div className={"shop-scene dark-scene fight-scene " + (manager.controller.name)}>
        {
          src.slotMachine &&
          <div className="shop-slot-machine">
          {
            src.slotMachine.map((slot, i) => 
            <div key={"shop-item shop-slot-" + i} id={"shop-slot-" + i} className="shop-slot">
            {
              (() => {
                switch (slot) {
                case "berry": return <Img key={"shop-item-" + i + "-berry"} src="/images/berry.png"/>
                case "seed": return <Img key={"shop-item-" + i + "-seed"} src="/images/seed.png"/>
                case "coin": return <Img key={"shop-item-" + i + "-coin"} src="/images/coin.png"/>
                case "insight": return <Img key={"shop-item-" + i + "-insight"} src="/images/insight.png"/>
                case "potion": return <Img key={"shop-item-" + i + "-potion"} src="/images/randompotion.png"/>
                case "runes": return <Img key={"shop-item-" + i + "-runes"} src="/images/rune.png"/>
                case "shards": return <Img key={"shop-item-" + i + "-shards"} src="/images/shard.png"/>
                case "relic": return <Img key={"shop-item-" + i + "-relic"} src="/images/relic2.png"/>
                case "remove": return <Img key={"shop-item-" + i + "-remove"} src="/images/remove.png"/>
                case "fight": return <Img key={"shop-item-" + i + "-fight"} src="/images/hard.png"/>
                default: return <div/>
                }
              })()
            }
            </div>)
          }
          </div>
        }
        { src.single && <div className="shop-title">Pick one</div> }
        <div className="shop-items-wrapper">
          <div className={"shop-items items-" + src.articles.length}>
          {
            src.articles.map((article,i) =>
              article.sold ? (
                <div key={"shop-article-sold-" + i} className={"shop-article sold shop-article-sold-" + article.type}/>
              ) : (
                article.type === "companion" ? (
                  <div className="shop-article-companion" key={"shop-article-" + i + "-" + (article.type) + "-" + (article.value ? article.value.key : 0)} onPointerDown={e => { this.toggleTooltip("item-" + i, e.pointerType === "touch"); if (e.pointerType === "touch") return; manager.run.room.shop.buy(i); }}>
                    <Entity src={ Object.assign({key: i, scale: 0.67 }, article.value) } onSelect={() => {}}/>
                    {article.price ? <div className="shop-price"><Img src={"/images/" + (article.currency || "gold") + ".png"}/><div className="shop-price-value">{article.price}</div></div> : ""}
                    <Tooltip className="tooltip companion-tooltip" placement="top" isOpen={article && !article.sold && this.state.tooltip === "game-entity-" + article.value.key} target={"game-entity-" + article.value.key} toggle={() => this.toggleTooltip("game-entity-" + article.value.key)}>
                      <b><img src={"/images/companion.png"}/>{ article.value.name }</b><br/>
                      <span className="shop-companion-skill"><b>Skill:</b>&nbsp;{article.value.skill.effect.replace(/\[|\]/g, '')}</span><br/>
                      <span className="shop-companion-auto"><b>Action:</b>&nbsp;{article.value.action.effect.replace(/\[|\]/g, '')}</span>
                      { this.tooltipTouch && <div className="tooltip-button" onClick={() => manager.run.room.shop.buy(i)}>Buy</div> }
                    </Tooltip>
                  </div>
                ) : (
                  <div key={"shop-article-" + i + "-" + (article.type) + "-" + (article.value ? article.value.key : 0)} className="shop-article">
                    <div key={"shop-item-wrapper-" + i + (article.type) + "-" + (article.value ? article.value.key : 0)} id={"shop-item-" + i} onPointerDown={e => { this.toggleTooltip("item-" + i, e.pointerType === "touch"); if (e.pointerType === "touch") return; manager.run.room.shop.buy(i); }} className="shop-item-wrapper">
                      <div key={"shop-item-item-" + i + (article.type) + "-" + (article.value ? article.value.key : 0)} className="shop-item">
                        {(() => {
                          switch (article.type) {
                            case "card": return <Card key={"shop-item-" + i + "-" + article.value.img} src={article.value} tier={article.value.tier}/>
                            case "health": return <Img key={"shop-item-" + i + "-health"} src="/images/health.png"/>
                            case "berry": return <Img key={"shop-item-" + i + "-berry"} src="/images/berry.png"/>
                            case "seed": return <Img key={"shop-item-" + i + "-seed"} src="/images/seed.png"/>
                            case "coin": return <Img key={"shop-item-" + i + "-coin"} src="/images/coin.png"/>
                            case "insight": return <Img key={"shop-item-" + i + "-insight"} src="/images/insight.png"/>
                            case "remove": return <Img key={"shop-item-" + i + "-remove"} src="/images/remove.png"/>
                            case "cleanse": return <Img key={"shop-item-" + i + "-cleanse"} src="/images/cleanse.png"/>
                            case "gift": return <Img key={"shop-item-" + i + "-gift"} src="/images/gift.png"/>
                            case "gold": return <Img key={"shop-item-" + i + "-gold"} src="/images/gold.png"/>
                            case "paws": return <Img key={"shop-item-" + i + "-paw"} src="/images/paws.png"/>
                            case "switchcompanion": return <Img key={"shop-item-" + i + "-switchcompanion"} src="/images/switchcompanion.png"/>
                            case "randompotion": return <Img key={"shop-item-" + i + "-randompotion"} src="/images/randompotion.png"/>
                            case "runes": return <Img key={"shop-item-" + i + "-runes"} src="/images/rune.png"/>
                            case "shards": return <Img key={"shop-item-" + i + "-shards"} src="/images/shard.png"/>
                            case "special": return <Img key={"shop-item-" + i + "-special"} src="/images/special.png"/>
                            case "empty": return <div/>
                            default: return <Img key={"shop-item-" + i + "-" + article.value.img} src={article.value.img}/>
                          }
                        })()}
                        {["health", "gold", "runes", "shards"].includes(article.type) && <div className="shop-article-value">{ article.value }</div>}
                      </div>
                      {article.price ? <div className="shop-price"><Img src={"/images/" + (article.currency || "gold") + ".png"}/><div className="shop-price-value">{article.price}</div></div> : ""}
                      {article.infinite ? <div className="shop-article-watermark"><Img src={"/images/infinite.png"}/></div> : (article.type === "relic" || article.type === "item" ? <div className="shop-article-watermark"><Img src={"/images/" + article.type + ".png"}/></div> : "")}
                    </div>
                    {(article.type === "card" || article.type === "relic" || article.type === "potion") && 
                      <Tooltip className="tooltip" placement="top" isOpen={article && !article.sold && this.state.tooltip === "shop-item-" + i} target={"shop-item-" + i} toggle={() => this.toggleTooltip("shop-item-" + i)}>
                        <b>{ article.type === "relic" ? <img src={"/images/relic.png"}/> : "" }{ article.value.name }</b>
                        { article.type === "card" ? "" : <span><br/>{article.value.effect.replace(/\[|\]/g, '')}</span> }
                        { this.tooltipTouch && <div className="tooltip-button" onClick={() => manager.run.room.shop.buy(i)}>Buy</div> }
                      </Tooltip>
                    }
                    {["berry", "coin", "seed", "remove", "cleanse", "randompotion", "paws", "switchcompanion"].includes(article.type) &&
                      <Tooltip className="tooltip" placement="top" isOpen={article && !article.sold && this.state.tooltip === "shop-item-" + i} target={"shop-item-" + i} toggle={() => this.toggleTooltip("shop-item-" + i)}>
                        { article.type === "berry" && <span><b>Heart berry</b><br/>{"Recover " + this.props.src.run.berryHp + " HP."}</span> }
                        { article.type === "coin" && <span><b>Sacred coin</b><br/>{"Gain " + this.props.src.run.coinGold + " gold."}</span> }
                        { article.type === "seed" && <span><b>Growth seed</b><br/>{"Gain " + this.props.src.run.seedExp + " exp."}</span> }
                        { article.type === "paws" && <span><b>Menagerie token</b><br/>{"Can be exchanged at the menagerie."}</span> }
                        { article.type === "switchcompanion" && <span><b>Reroll companion</b><br/>{"Present a different companion."}</span> }
                        { article.type === "remove" && <span>Remove a card from your deck.</span> }
                        { article.type === "cleanse" && <span>Cure a random curse</span> }
                        { article.type === "randompotion" && <span>Get a random potion.</span> }
                        { this.tooltipTouch && <div className="tooltip-button" onClick={() => manager.run.room.shop.buy(i)}>Buy</div> }
                      </Tooltip>
                    }
                    {this.tooltipTouch && ["gold", "gift", "shards", "insight", "health", "special"].includes(article.type) &&
                      <Tooltip className="tooltip" placement="top" isOpen={article && !article.sold && this.state.tooltip === "shop-item-" + i} target={"shop-item-" + i} toggle={() => this.toggleTooltip("shop-item-" + i)}>
                        <div className="tooltip-button" onClick={() => manager.run.room.shop.buy(i)}>Buy</div>
                      </Tooltip>
                    }
                    {article.type === "card" ? <div className="shop-article-info" onClick={() => manager.setState({focus: article.value})}><Img src="/images/info.png"/></div> : ""}
                  </div>
                )
              )
            )
          }
          </div>
        </div>
        {/*<div className="shop-sign">
          <div className="shop-name">{ src.name }</div>
          <div className="shop-description">{ src.description }</div>
        </div>
        <div className="fight-end-turn"><SceneButton onClick={() => manager.run.room.cleanup()}>Move on</SceneButton></div>*/}
      </div>
    );
  }
}

